import {Vector2} from './vector'
import {canvas, colors} from './world'
import utils, { mapRange } from './utils'
import {MidiMaestro} from './midi'

// Y ahora, pequeña hada... ayúdanos a encontrar el corazón.

class FairyField{
    constructor(ctx, position) {
        this.ctx = ctx;
        this.fairies= [];
        this.position = position;
        for (let i = 0; i < 22; i++) {
            this.position.y += Math.sin(i * 5) * 10;
            let fairy = new Fairy(this.ctx, new Vector2(this.position.x + (i * 20), this.position.y));
            this.fairies.push(fairy);
        }

    }

    rise() {
        // this.faries.forEach((fairy) => {
        //     fairy.rise();
        // });
    }

    update() {
        this.ctx.fillStyle = colors[0];
        this.fairies.forEach( (fairy, index) => fairy.update(index));
    }


}

class Fairy{
    constructor(ctx, position) {
        this.position = position;
        this.velocity = new Vector2();
        this.acceleration = new Vector2();
        this.ctx = ctx;
        this.spawnTime = performance.now()
    }

    rise() {
        this.velocity = new Vector2(0, 5);
    }

    update(index){
        this.draw();
        this.velocity.y = 2.2 * Math.sin( (performance.now() * 0.007) + (index) ) 
        this.position.y += this.velocity.y;

       //this.position.round();
    }

    
    draw() {
        //this.ctx.beginPath();
        this.ctx.fillRect(this.position.x, this.position.y, 5, 5);


    }
}

export {FairyField}